import { ReportHistory, ReportHistoryItem } from '../types/history';

const STORAGE_KEY = '@ehub/report-history';
const MAX_HISTORY_ITEMS = 20;

export const getReportHistory = (): ReportHistory => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return { items: [] };
    return JSON.parse(stored);
  } catch (error) {
    console.error('Error reading report history:', error);
    return { items: [] };
  }
};

export const addReportToHistory = (item: ReportHistoryItem): void => {
  try {
    const history = getReportHistory();
    const existingIndex = history.items.findIndex(i => i.taskId === item.taskId);

    if (existingIndex !== -1) {
      history.items.splice(existingIndex, 1);
    }

    history.items.unshift(item);

    if (history.items.length > MAX_HISTORY_ITEMS) {
      history.items = history.items.slice(0, MAX_HISTORY_ITEMS);
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
  } catch (error) {
    console.error('Error saving report to history:', error);
  }
};

export const removeReportFromHistory = (id: string): void => {
  try {
    const history = getReportHistory();
    history.items = history.items.filter(item => item.id !== id);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
  } catch (error) {
    console.error('Error removing report from history:', error);
  }
};